import { DEFAULT_THEME_CSS_VARIABLES } from "./defaultThemeCssVars";

export const DEFAULT_THEME = {
  default_theme: {
    value: "default_theme",
    cssVariables: DEFAULT_THEME_CSS_VARIABLES,
  },
};
